import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { message } from 'antd'


export const getAllFaq = createAsyncThunk('getFaqStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingFaqDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/viewAllFaqs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(faqDetailResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(faqDetailClear())
                message.error(error) 
            })
    }
)



const FaqGetSlice = createSlice({
    name: 'faqsApi',
    initialState: {
        faqData: null,
        loadingfaq: false,
    },
    reducers: {
        gettingFaqDetail: state => {
            state.loadingfaq=true
            state.faqData=null
        },
        faqDetailResponse: (state, action)=>{
            state.faqData= action.payload
            state.loadingfaq= false
        },
        faqDetailClear: (state)=>{
            state.faqData= null
            state.loadingfaq= false
        },
    },
})
export const { 
    gettingFaqDetail, faqDetailResponse, faqDetailClear
} = FaqGetSlice.actions;
export default FaqGetSlice.reducer;